import { render, staticRenderFns } from "./MainPage2.vue?vue&type=template&id=28db4875"
import script from "./MainPage2.vue?vue&type=script&lang=js"
export * from "./MainPage2.vue?vue&type=script&lang=js"
import style0 from "./MainPage2.vue?vue&type=style&index=0&id=28db4875&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports